export function notEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  if (value === null || value === undefined) {
    return false;
  }
  const testDummy: TValue = value; // eslint-disable-line
  return true;
}

export function flatMapOptional<TInput, TOutput>(
  input: TInput | null | undefined,
  f: (input: TInput) => TOutput | null
): TOutput | null {
  if (notEmpty(input)) {
    return f(input);
  }
  return null;
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export function assertUnreachable(x: never): never {
  throw new Error("Didn't expect to get here");
}
/* eslint-enable @typescript-eslint/no-unused-vars */

class ArrayExtensions<T> {
  underlying: Array<T>;

  constructor(underlying: Array<T>) {
    this.underlying = underlying;
  }
}

interface ArrayExtensions<T> {
  compactMap<TNew>(f: (original: T) => TNew | null): Array<TNew>;
}

ArrayExtensions.prototype.compactMap = function compactMapImpl<T, TNew>(
  this: ArrayExtensions<T>,
  f: (original: T) => TNew | null
): Array<TNew> {
  return this.underlying.flatMap((element) => {
    const mapped = f(element);
    if (mapped) {
      return [mapped];
    }
    return [];
  });
};

/* eslint-disable no-extend-native */
declare global {
  export interface Array<T> {
    tawkitExtensions: () => ArrayExtensions<T>;
  }
}

Array.prototype.tawkitExtensions = function tawkitExtensionsImpl<T>(
  this: Array<T>
): ArrayExtensions<T> {
  return new ArrayExtensions(this);
};
/* eslint-enable no-extend-native */
